import ReactLogo from '../../assets/kflogo_white.svg'

const FooterLogo = () => {
    return (
        <img style={{ height: "20px"}} src={ReactLogo} alt='logo' />
    )
}

export default FooterLogo